<div class="flex flex-col gap-2">
  @for (item of items(); track item.label) {
    <div
      class="flex items-center gap-6 rounded px-1"
      [class.cursor-pointer]="item.count > 0"
      [class.hover:bg-shikenso-pink-base-12]="item.count > 0"
      [attr.role]="item.count > 0 ? 'button' : null"
      [attr.tabindex]="item.count > 0 ? '0' : null"
      [attr.aria-disabled]="item.count > 0 ? 'false' : 'true'"
      (click)="item.count > 0 && itemClicked.emit(item)"
      (keydown.enter)="item.count > 0 && itemClicked.emit(item)"
      (keydown.space)="item.count > 0 && itemClicked.emit(item); $event.preventDefault()"
    >
      <span #labelRef class="shrink-0 min-w-fit" [style.width.px]="labelWidth() || null">
        {{ item.label | translate }}
      </span>

      @if (loading()) {
        <ngx-skeleton-loader class="flex h-5" [theme]="{ height: '20px', width: '28px', 'border-radius': '100vw' }" />
      } @else {
        <div
          class="flex items-center justify-end rounded-full transition-all duration-300 shrink-0"
          [ngClass]="item.colorClass"
          [style.height.px]="barHeight()"
          [style.width.px]="barWidth(item.count)"
        >
          <span class="text-xs font-semibold pr-2 text-shikenso-purple-base select-none">{{ item.count }}</span>
        </div>
      }
    </div>
  }
</div>
